import { render } from "./TicketBoardView.vue?vue&type=template&id=7e71f2da"
import script from "./TicketBoardView.vue?vue&type=script&lang=js"
export * from "./TicketBoardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__